import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface DeleteEventParams {
    deviceId: string;
    eventId: number;
}

export function useDeviceEventDeleteMutation() {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async ({ deviceId, eventId }: DeleteEventParams) => {
            await OCGatewayClient.request('deleteEvent', {
                deviceId,
                eventId
            });
            return { deviceId, eventId };
        },
        onSuccess: ({ deviceId, eventId }) => {
            // Invalidate the specific event query
            queryClient.invalidateQueries({ 
                queryKey: ['getEvent', deviceId, eventId],
                exact: false
            });
            
            // Invalidate device events query
            queryClient.invalidateQueries({ 
                queryKey: ['getDeviceEvents', deviceId] 
            });
            
            // Invalidate general events query
            queryClient.invalidateQueries({ 
                queryKey: ['getEvents'] 
            });
        }
    });

    return mutation;
}
